import { render, staticRenderFns } from "./CondominiumComponent.vue?vue&type=template&id=4abae182&scoped=true"
import script from "./CondominiumComponent.vue?vue&type=script&lang=js"
export * from "./CondominiumComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abae182",
  null
  
)

export default component.exports